import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import image1 from '../images/kitchen.jpg';
import image2 from '../images/kitchen2.jpg';
import image3 from '../images/kitchen3.jpg';
import Services from './Services';
import About from './About';


// Styled components
const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  h2{ color:white;
  }
  margin: 0 auto;
  overflow: hidden;

  @media (max-width: 768px) {
    /* Additional styles for tablet devices if needed */
  }

  @media (max-width: 480px) {
    /* Additional styles for mobile devices if needed */
  }
`;

const SliderImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  max-height: 700px; /* Maximum height */
  transition: opacity 0.5s ease-in-out;

  @media (max-width: 768px) {
    max-height: 400px; /* Smaller max height on tablet devices */
  }

  @media (max-width: 480px) {
    max-height: 300px; /* Even smaller max height on mobile devices */
  }
`;

const OverlayContent = styled.div`
  position: absolute;
top:40%;
  left: 20px;
  right: 20px;
  color: white;
  padding: 20px;
  width:700px;
  border-radius: 10px;
  text-align: left;
  box-sizing: border-box;

  @media (max-width: 768px) {
    bottom: 10px;
    padding: 10px;
  }

  @media (max-width: 480px) {
    bottom: 5px;
    padding: 6px;
    width:380px;
  }
`;



const Home = () => {
  // Define the images to be displayed
  const images = [image1, image2, image3];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  

  useEffect(() => {
    const interval = setInterval(() => {
      // Change the image every 5 seconds
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change the time interval (in milliseconds) as needed

    return () => clearInterval(interval); // Clear the interval on component unmount
  }, [images.length]);

  return (
    <div className='wholecontainer'>
    <SliderContainer>
      <SliderImage style={{ width: '100%', height: '800px' }}
        src={images[currentImageIndex]}
        alt={`Slide ${currentImageIndex + 1}`}
      />
      <OverlayContent>
        <h2 className='wholecontainer'>
          SmartStone Marble Ind LLC, the leading stone contractor that has been built with a prominent reputation is known
          for delivering quality services on time at a competitive price.
        </h2>
       
      </OverlayContent>
    </SliderContainer>
    <div>
      <div>
       <Services/>
       <About/>
      </div>
    </div>
    
    </div>
  );
};

export default Home;
